import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { default as Footer } from "../../Components/Footer/FooterSmall";
import { default as Header } from "../../Components/Header2/Header2";
import "./RoleAdminDashboard.css";

const sections = [
  {
    key: "roles",
    label: "Manage Roles",
    path: "/user-admin/roles",
    icon: "👥",
    description: "Create and edit user roles within the system."
  },
  {
    key: "permissions",
    label: "Edit Permission Definitions",
    path: "/user-admin/permissions",
    icon: "📝",
    description: "Configure the available permissions and their definitions. Permissions are tags that define what actions a user can perform in the system."
  },
  {
    key: "assign-role-permissions",
    label: "Assign Permissions to Roles",
    path: "/user-admin/assign-role-permissions",
    icon: "🔗",
    description: "Map permissions to specific roles. Define what actions each role can perform in the system."
  }
];

export const RoleAdminDashboard: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className='generalPage'>
      <Header />
      <div className="roleadmin-container">
        <div className='pageContainer'>

          <div className="button-container">
            <button
              className="back-button"
              onClick={() => navigate('/')}
            >
              <FontAwesomeIcon icon={faArrowLeft} /> Back to Home
            </button>
          </div>

          <h1 className="user-admin-title">Role Admin Dashboard</h1>
          <div className="dashboard-subtitle">Manage Roles and Permissions</div>
          <div className="pills-container">
            {sections.map((section) => (
              <div key={section.key} className="pill-box">
                <div className="pill-icon">{section.icon}</div>
                <h2 className="pill-title">{section.label}</h2>
                <p className="pill-description">{section.description}</p>
                <Link to={section.path} className="pill-link">
                  Go to {section.label}
                </Link>
              </div>
            ))}
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default RoleAdminDashboard;
